import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';

export default function Header() {
    const { toggleLanguage, language } = useLanguage();

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <header className="header">
            <nav className="nav">
                <Link to="/" className="logo">
                    <span className="bracket">&lt;</span>Lino/<span className="bracket">&gt;</span>
                </Link>

                <div className="nav-links">
                    <Link to="/" className="nav-link" onClick={e => { if (window.location.pathname === '/') { e.preventDefault(); scrollTo('about'); } }}>{language === 'de' ? 'Über mich' : 'About'}</Link>
                    <Link to="/" className="nav-link" onClick={e => { if (window.location.pathname === '/') { e.preventDefault(); scrollTo('projects'); } }}>{language === 'de' ? 'Projekte' : 'Projects'}</Link>
                    <Link to="/contact" className="nav-link">{language === 'de' ? 'Kontakt' : 'Contact'}</Link>
                    <button className="icon-button" onClick={toggleLanguage}>
                        {language.toUpperCase()}
                    </button>
                </div>
            </nav>
        </header>
    );
}
